// Let a button's feedback or a scroll paint before analytics/attribution work.
// The fallback also lets navigation finish when animation frames are suspended.
export function afterNextPaint() {
  return new Promise(resolve => {
    let frame;
    let nextTask;
    const finish = () => {
      clearTimeout(fallback);
      clearTimeout(nextTask);
      if (frame !== undefined) cancelAnimationFrame(frame);
      resolve();
    };
    const fallback = setTimeout(finish, 100);
    frame = requestAnimationFrame(() => { nextTask = setTimeout(finish, 0); });
  });
}
